import { Spin } from "antd";
import { Colors } from './utils';
import { useTheme } from "../components/ThemeContext";

/**
 * Component used to show navigation message
 */
const NavigationMessage = () => {
  // Use the hook inside the component to get the theme
  const { theme } = useTheme();

  return (
    <div className="centerPage">
      <div className="divAlignCenter"
     >
        <Spin>
          <p style={{ 
            color: theme === "dark" ?Colors.darkText : Colors.lightText
            }}>
            Please Wait, Navigation won't work while loading Unity WebGL
          </p>
        </Spin>
      </div>
    </div>
  );
};

export default NavigationMessage;
